import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

export const MarginContainer = styled.div<{
  color?: string;
  leftMargin?: boolean;
}>`
  ${({ color }) => (color ? `color: ${color}` : "")};
  ${({ leftMargin }) =>
    leftMargin
      ? `margin-left: ${Variables.space50};`
      : `margin-right: ${Variables.space50};`};
`;
